module.exports = __webpack_public_path__ + "img/高通5.18f360ec.png";